import React, {useEffect, useRef, useState} from 'react';
import {Box, Sheet, Stack, Typography} from '@mui/joy';
import {ProjectModel} from "../model/project";
import {ProjectRepository} from "../repository/ProjectRepository";
import {useParams} from "react-router";
import LoadingPage from "./Loading";
import TimeOutPage from "./TimeOut";

function WorkPage() {
    const {title} = useParams()
    const repo = new ProjectRepository()
    const [project, setProject] = useState<ProjectModel>(new ProjectModel());
    const [error, setError] = useState<boolean>(false);
    useEffect(() => {
        if (title != null) {
            repo.getAllProject().then(value => {
                if (value.length > 0) {
                    const projectFind: ProjectModel = value.find(value1 => value1.title
                        .toLowerCase()
                        .replaceAll(' ', '-')
                        .localeCompare(title) == 0) as ProjectModel;
                    setProject(projectFind);
                }
            }).catch(reason => setError(true));
        }
    }, [])

    return (
        <Sheet sx={{paddingTop: 2, paddingX: {xs: 2, md: 6}}}>
            {!(project.title.length > 0) && (
                <LoadingPage/>
            )}
            {(project.title.length > 0 && error) && (
                <TimeOutPage/>
            )}
            {(project.title.length > 0 && !error) && (
                <Sheet sx={{minHeight: {xs: '95vh', md: '67vh'}, paddingY: 0, borderRadius: 8}}>
                    <Stack alignItems='start'
                           spacing={2}
                           direction={{xs: 'column', md: 'column'}}>
                        <Stack width={{xs: '100%', md: 'auto'}} padding={2} spacing={1} direction="column">
                            <Typography color='primary' level="title-md">{project.category}</Typography>
                            <Typography key={project.title} level='h3' fontWeight='lg'>{project.title} </Typography>
                        </Stack>
                        <Stack width='100%' alignItems='center'>
                        <Box  bgcolor='neutral.50' display='flex' justifyContent='center' alignItems='center'
                             height={{xs: window.innerWidth - 32, md: window.innerWidth * 0.50}}
                             maxHeight={window.innerHeight - 96}
                             maxWidth={window.innerWidth - 96}
                             width={{xs: window.innerWidth - 96, md: window.innerWidth * 0.50}}>
                            <Box component="img" src={project.url} maxWidth="100%" maxHeight="100%"/>
                        </Box>
                        </Stack>
                        <Stack width={{xs: '100%', md: 'auto'}} padding={2} spacing={1} direction="column">
                            <Typography>{project.description}</Typography>
                            <br/>
                            <Typography fontWeight='lg'>Technologies used: </Typography>
                            <Typography>{project.technologiesUsed.join(" • ")} </Typography>
                        </Stack>
                    </Stack>
                </Sheet>
            )}
        </Sheet>
    );
}

export default WorkPage;